<template>
  <common-layout-template :isBread="true" :breadHeading="'プライバシーポリシー'">
    <template v-slot:body>
      <static-contents />
    </template>
  </common-layout-template>
</template>

<script>
import StaticContents from '@/components/static/StaticContentsPrivacyPolicy';
import CommonLayoutTemplate from '@/components/templates/CommonLayoutTemplate';
import Meta from '@/assets/json/meta.json';

export default {
  name: 'PrivacyPolicy',
  components: {
    StaticContents,
    CommonLayoutTemplate,
  },
  data() {
    return {
    };
  },
  mounted() {
    document.title = Meta.default.title;
    document.querySelector('meta[name="description"]').setAttribute('content', Meta.default.description);
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@charset "UTF-8";

</style>
